// Labels and tag colors of the customer portal (dashboard namespace, English sentence keys).

export const offerStatus = (t, status) =>
  ({
    Sent: { text: t("Waiting for your answer"), color: "processing" },
    Accepted: { text: t("Accepted"), color: "success" },
    Declined: { text: t("Declined"), color: "default" },
    "Partially Invoiced": { text: t("In progress"), color: "success" },
    Invoiced: { text: t("Invoiced"), color: "success" }
  })[status] || { text: status, color: "default" };

export const changeOrderState = (t, state) =>
  ({
    offered: { text: t("Waiting for your answer"), color: "processing" },
    ordered: { text: t("Ordered, price open"), color: "warning" },
    approved: { text: t("Approved"), color: "success" },
    rejected: { text: t("Rejected"), color: "default" }
  })[state] || { text: state, color: "default" };

export const paymentState = (t, state) =>
  ({
    open: { text: t("Open"), color: "processing" },
    partially_paid: { text: t("Partially paid"), color: "warning" },
    overdue: { text: t("Overdue"), color: "error" },
    paid: { text: t("Paid"), color: "success" },
    cancelled: { text: t("Cancelled"), color: "default" },
    not_payable: { text: t("Correction"), color: "default" },
    unknown: { text: t("Sent"), color: "default" }
  })[state] || { text: state, color: "default" };

export const documentKind = (t, kind) =>
  ({
    work_report: t("Work report"),
    acceptance: t("Acceptance protocol"),
    inspection: t("Inspection protocol"),
    site_diary: t("Site diary"),
    photo_report: t("Photo report"),
    file: t("Document")
  })[kind] || t("Document");

export const projectStatus = (t, status) =>
  ({
    "JUST ADDED": t("Planned"),
    "IN PROGRESS": t("In progress"),
    COMPLETED: t("Completed"),
    ISSUES: t("In progress"),
    REVISION: t("In progress"),
    REJECTED: t("Cancelled")
  })[status] || status;
